<template>
	<!-- Program Results -->
    <table class="program-table">
        <thead>
            <tr>
                <th class="program-heading" @click="store.toggleSortOrder"><i class="fa-solid fa-sort"></i>Program</th>
                <th v-for="col in typeColumns" :key="col" class="not-first-col">{{ col }}</th>
                <th>Delivery</th>
            </tr>
        </thead>
        <tbody>
            <template v-for="(program, index) in filteredPrograms" :key="program.name">
                <!-- Main row with dynamic class -->
                <tr @click="program.expanded = !program.expanded" :class="[ index % 2 === 0 ? 'bg-white' : 'bg-light', 'main-row', { expanded: program.expanded } ]">
                    <td class="program-name">
                        <button>
                            <i class="fa-regular fa-angle-down" :class="{ 'rotated': program.expanded }"></i>
                            {{ program.name }}
                        </button>
                    </td>
                    <td v-for="type in typeColumns" :key="type" class="available-program-type-indicator not-first-col">
                        <span class="type-indicator" :class="{ filled: program.types[type], empty: !program.types[type] }"></span>
                    </td>
                    <td class="available-delivery-type">
                        <span :class="{ 'is-faded': !program.delivery.online }">
                            <i class="fa-regular fa-desktop"></i>
                        </span>
                        <span :class="{ 'is-faded': !program.delivery.on_campus }">
                            <i class="fa-regular fa-landmark"></i>
                        </span>
                    </td>
                </tr>
                <!-- Expanded detail row with matching background -->
                <tr v-if="program.expanded" :class="{'bg-white': index % 2 === 0, 'bg-light': index % 2 !== 0}" class="expanded-row">
                    <td colspan="100%">
                        <div class="college-info">
                            <!-- College/Dept. -->
                            <div v-if="program.college" class="mb-1">
                                College:
                                    <span v-if="program.college.url">
                                        <a :href="program.college.url" class="link">{{ program.college.name }}</a>
                                    </span>
                                <span v-else>
                                    {{ program.college.name }}
                                </span>
                            </div>
                            <div v-if="program.department" class="mb-1">
                                Department:
                                <span v-if="program.department.url">
                                    <a :href="program.department.url" class="link">{{ program.department.name }}</a>
                                </span>
                                <span v-else>
                                    {{ program.department.name }}
                                </span>
                            </div>
                            <!-- Details -->
                            <div v-if="program.customDetails || program.details" class="details">
                                <span v-if="program.details" class="details-label">View Details for:</span>
                                <!-- Show details -->
                                <span v-if="program.details" v-for="(detail, type) in program.details" :key="type">
                                    <a 
                                        :href="detail.url" 
                                        class="link link--styled link--arrow"
                                        :target="isExternal(detail.url) ? '_blank' : null"
                                        :rel="isExternal(detail.url) ? 'noopener noreferrer' : null"
                                    >
                                        {{ detail.label }}
                                    </a>
                                </span>
                                <!-- Show customDetails (WYSIWYG data for custom links) if available -->
                                <div v-if="program.customDetails" v-html="program.customDetails" class="custom-links"></div>
                            </div>
                        </div>
                    </td>
                </tr>
            </template>

            <tr v-if="filteredPrograms.length === 0" class="no-results">
                <td colspan="100%" class="text-center">
                    Sorry, no exact matches were found, please adjust your search criteria.
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useProgramStore } from '@ProgramList/stores/programStore';

const route = useRoute();
const store = useProgramStore();
const { filteredPrograms } = storeToRefs(store);

function isExternal(url: string): boolean {
  return !url.startsWith('/') && !url.includes(window.location.hostname);
}

// update results based on query params
onMounted(async () => {
    await store.loadProgramsFromDom();
    store.initFromRoute(route);
});

// static table column headings
const typeColumns = [
	'bachelor',
	'minor',
	'master',
	'doctorate',
	'certificate',
];
</script>